import { createZodDto } from './zod';

import { z } from 'zod';

export const CreateOrgDocumentSchema = z.object({
  title: z.string().trim().min(1),
  description: z.string().trim().nullable().optional(),
  // null/omitted = diffusé/visible par toute l'organisation
  folderId: z.number().int().nullable().optional(),
  effectiveDate: z.coerce.date().nullable().optional(),
  nextReviewDate: z.coerce.date().nullable().optional(),
  // must reference a PrivateFile already uploaded via POST /org-documents/files
  fileId: z.number().int(),
});

export class OrgDocumentCreateDto extends createZodDto(
  CreateOrgDocumentSchema,
) {}

// A document's audience is defined when the document is first published. A
// subsequent file version must keep that same scope, so `folderId` is
// deliberately not accepted by this endpoint.
export const CreateOrgDocumentVersionSchema = CreateOrgDocumentSchema.omit({
  folderId: true,
}).strict();

export class OrgDocumentCreateVersionDto extends createZodDto(
  CreateOrgDocumentVersionSchema,
) {}
